export default __webpack_public_path__ + "static/badge-dont-2-bold-dark-0866bc0107ffa606f740d16e8f2a521485b979f25c8e91490340c9b0b06b6e30.png";